/* eslint-disable @typescript-eslint/naming-convention */

export type ILeadsApi = ILeadApi[];

export interface ILeadApi {
  email: string;
  id: number;
  message: string;
  name: string;
  phone: string;
  read_status: 'READ' | 'NEW';
  timestamp: string;
}

export interface IPeriodsApi {
  today: ILeadsPointApi;
  yesterday: ILeadsPointApi;
  seven_days: ILeadsPointApi;
  thirty_days: ILeadsPointApi;
  this_month: ILeadsPointApi;
  last_month: ILeadsPointApi;
  all: ILeadsPointApi;
}

export interface ILeadsPointApi {
  pointStart: number;
  begin: number;
  end: number;
}

export interface ILeadsTotalsApi {
  total: number;
  seen: number;
  new: number;
}
